import { network } from './network';

export async function getUserInfo(opts) {
	const res = await network({
		url: '/api/v1/user_info',
		method: 'post',
		params: {},
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}

export async function getAuthTicket(opts) {
	const res = await network({
		url: '/api/v1/app/auth_ticket',
		method: 'post',
		headers: {
			'Token': opts.token,
			'App-Id': opts.appid
		}
	});

	if (res.code !== 0) {
		return Promise.reject(res);
	}

	return res;
}
